module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-19-a437c181a7d03b93529c6b7b9a47393c.png";